<ng-container>
  <ion-grid class="ion-no-padding">
    <ion-row class="ion-justify-content-center">
      <ion-button class="sign-in-button" (click)="loginWithGoogle()" [color]="color === 'light' ? 'white' : 'dark'">
        <ion-icon slot="start" name="logo-google"></ion-icon>
        <ion-label [color]="color === 'light' ? 'dark' : 'white'">{{ actionPrefix }} with Google</ion-label>
      </ion-button>
    </ion-row>

    @if (!isAndroid()) {
      <ion-row class="ion-justify-content-center">
        <ion-button class="sign-in-button" (click)="loginWithApple()" [color]="color === 'light' ? 'white' : 'dark'">
          <ion-icon slot="start" name="logo-apple"></ion-icon>
          <ion-label [color]="color === 'light' ? 'dark' : 'white'">{{ actionPrefix }} with Apple</ion-label>
        </ion-button>
      </ion-row>
    }
  </ion-grid>
</ng-container>
